import { addTaskTemplate, removeTaskTemplate, listTaskTemplate } from '@/api/task/taskTemplate'

const state = {
  taskTemplateList: [],
  formStatus: false,
}

const actions = {
  async saveTaskTemplate({ dispatch }, data) {
    let task = this.state.task.checkTaskInfo;
    data = Object.assign({}, task);
    delete data._id;
    const project = this.state.courseAndProject.project;
    data.project = project._id;
    data.originTaskId = task._id;
    data = Object.assign(
        {
            flowJsonData: {},
            flowMapData: {},
            flowTriggerMap: {},
            subTaskGraph: {},
            subTaskList: []
        },
        data
    )
    console.log('data :>> ', data);
    // await addTaskTemplate(data);
    this.dispatch('global/showSuccessMsg', '操作成功');
    dispatch('refreshTaskTemplateList')
  },
  async refreshTaskTemplateList({ commit }) {
    commit('SET_TASK_LIST', [])
    const project = this.state.courseAndProject.project;
    if (!project._id) {
      return;
    }
    const taskListRes = await listTaskTemplate({
      project: project._id,
      perPage: 1000
    })
    if (taskListRes.code == 200) {
      commit('SET_TASK_LIST', taskListRes.data.rows)
    }
  }
}

const mutations = {
  SET_TASK_LIST(state, taskList) {
    state.taskList = taskList
  },
  SET_FORM_STATUS(state, value) {
    state.formStatus = value;
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
